import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillAttachmentPreviewBlockedWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: ${Spacing.S32};
  border: 1px dashed ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey100};
`

export const CenteredContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: auto;
`
